if (!customElements.get('fake-select')) {
    class FakeSelect extends HTMLElement {
        constructor() {
            super();
            this.isOpen = false;
            this.selectChanged = new CustomEvent('fake-select:changed', {
                bubbles: true,
                value: this.value
            });
        }

        connectedCallback() {
            this.dropdown = this.querySelector('[data-dropdown]');
            this.selectValue = this.querySelector('[data-fake-select-value]');
            this.selectOptions = [...this.querySelectorAll('[data-fake-option]')];
            this.rotateEl = this.querySelector('[data-rotate]');
            this.expandingParent = this.closest('[data-fake-select-expanding-wrapper]');

            window.addEventListener('click', (e) => {
                if (!this.contains(e.target)) {
                    this.close();
                    return;
                }
            });

            this.addEventListener('click', (e) => {
                const clickedElement = e.target.closest('[data-dropdown-action]');
                if(!clickedElement) return;

                const {
                    dropdownAction: action,
                    value
                } = clickedElement.dataset;

                switch (action) {
                    case 'toggle-dropdown':
                        this.isOpen = !this.isOpen;

                        if (this.isOpen) {
                            clickedElement.classList.add('open');
                            clickedElement.setAttribute('aria-expanded', 'true');
                            this.open();
                            return;
                        }
                        clickedElement.classList.remove('open');
                        clickedElement.setAttribute('aria-expanded', 'false');
                        this.close();

                    break;
                    case 'select':
                      this.value = value;
                      this.selectValue.innerHTML = clickedElement.innerHTML;
                      this.selectOptions.forEach(el => {
                        if (el.querySelector(`[data-value="${value}"]`)) {
                          el.querySelector(`[data-value="${value}"] [data-checkmark]`)?.classList.remove('hidden');
                          this.dataset.value = value;
                        } else {
                          el.querySelector(`[data-value] [data-checkmark]`)?.classList.add('hidden');
                          this.close();
                        }
                      });
                      this.dispatchEvent(this.selectChanged);
                    break;
                    case 'url':
                        this.value = value;
                        window.document.location = value
                    break;
                    default: break;
                }
            });
        }

        open() {
            if (!this.dropdown) return;
            this.dropdown.removeAttribute('inert');
            this.dropdown.style.height = `${this.dropdown.scrollHeight}px`;
            if (this.expandingParent) this.expandingParent.style.height = `${this.expandingParent.scrollHeight + this.dropdown.scrollHeight}px`;
            if (this.rotateEl) this.rotateEl.style.transform = 'rotate(-180deg)';
            this.style.zIndex = 100;
        }

        close() {
            if (!this.dropdown) return;
            this.dropdown.setAttribute('inert', '');
            this.dropdown.style.height = '0px';
            if (this.expandingParent) this.expandingParent.style.height = null;
            if (this.rotateEl) this.rotateEl.style.transform = null;
            this.isOpen = false;
            setTimeout(() => this.style.zIndex = null, 300);
        }
    }

    customElements.define('fake-select', FakeSelect);
}